import { KENALL } from '@ken-all/kenall'

const apiBaseUrl = process.env.VITE_KENALL_API_BASE_URL
const apiKey = process.env.VITE_KENALL_API_KEY || ''

export const kenall = new KENALL(apiKey, {
  apibase: apiBaseUrl,
  timeout: 10000,
})
